import React, { createContext, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getAccess } from '../services/aiService';

const AiAccessContext = createContext({
  hasAiAccess: false,
  aiAccessLoading: false,
});

export function AiAccessProvider({ children }) {
  const authToken = useSelector(({ auth }) => auth.authToken);
  const authenticatedUser = useSelector(({ auth }) => auth.user);
  const [accessState, setAccessState] = useState({
    authToken: null,
    hasAccess: false,
    loading: false,
  });
  const isAuthenticated = Boolean(authToken && authenticatedUser);
  const hasAiAccess = isAuthenticated && accessState.authToken === authToken && accessState.hasAccess;
  const aiAccessLoading = isAuthenticated && (accessState.authToken !== authToken || accessState.loading);

  useEffect(() => {
    let isCurrent = true;

    if (!isAuthenticated) {
      setAccessState({ authToken: null, hasAccess: false, loading: false });
      return () => {
        isCurrent = false;
      };
    }

    setAccessState({ authToken, hasAccess: false, loading: true });

    getAccess()
      .then((response) => {
        if (isCurrent) {
          setAccessState({ authToken, hasAccess: response && response.hasAccess === true, loading: false });
        }
      })
      .catch(() => {
        if (isCurrent) {
          setAccessState({ authToken, hasAccess: false, loading: false });
        }
      });

    return () => {
      isCurrent = false;
    };
  }, [authToken, authenticatedUser, isAuthenticated]);

  return <AiAccessContext.Provider value={{ hasAiAccess, aiAccessLoading }}>{children}</AiAccessContext.Provider>;
}

export const useAiAccess = () => useContext(AiAccessContext);
